export default __webpack_public_path__ + "static/media/skel-user.1f1285f0.png";